<template>
  <PropertyTypeForm class="content-block"></PropertyTypeForm>
</template>

<script>
import PropertyTypeForm from 'CORE/components/property-type/form'

export default {
    name: 'PropertyTypeNewView',
    components: {
        PropertyTypeForm,
    },
}
</script>

